<div class="modal-header">
  <h5 class="modal-title">Rule Violations</h5>
</div>

<div class="modal-body">
  @if (ruleViolations.documentRules.length > 0) {
    <div
      class="document-rule-section"
      >
      <img src="assets/images/fa-exclamation-circle-o.png" class="ms-2 float-start exclamation-img" alt="Exclamation point" />
      <span class="ms-3">
        Document(s) need attention. Close this modal and hover over the "<i class="fa-solid fa-triangle-exclamation"></i> Needs Attention" status chips in the document list to view rule violations.
      </span>
    </div>
  }
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn-primary"
    (click)="closeModal()"
    >
    Close
  </button>
</div>
